import AppLayout from '../../layouts/AppLayout.jsx';

const LoadingPage = () => (
    <AppLayout sidebar>
        <section className="usa-section">
            <div className="grid-container">
                <div className="usa-prose">
                    <h1>Checking your session</h1>
                    <p>Please wait while we confirm your access.</p>
                </div>
            </div>
        </section>
    </AppLayout>
);

export default LoadingPage;
